import React, { useRef, useEffect, useState } from 'react';
import SupportWindow from './SupportWindow';
import Avatar from './Avatar';

const SupportEngine = () => {
  const wrapperRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setVisible(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={wrapperRef}>
      <SupportWindow visible={visible} />
      <Avatar
        onClick={() => setVisible(true)}
        style={{ position: 'fixed', bottom: '24px', right: '24px' }}
      />
    </div>
  );
};

export default SupportEngine;
